import Star from "../components/svg/Star";
import QuestionMark from "../components/svg/QuestionMark";

export const GameVariants = {
    STANDARD: "standard",
    JUMPSTART: "jumpstart",
    //This is for custom rules - probably need a new name at some point
    FUN: "fun"
}

export const TimeVariants = {
    CLASSIC: {imageSrc: "/classic_symbol.png", title: "Classical", value: "classic"},
    RAPID: {imageSrc: "/rapid_symbol.png", title: "Rapid", value: "rapid"},
    BLITZ: {imageSrc: "/blitz_symbol.png", title: "Blitz", value: "blitz"},
    BULLET: {imageSrc: "/bullet_symbol.png", title: "Bullet", value: "bullet"}
}

export const MoveRatingCategories = {
    BEST_MOVE: {symbol: (size) => <Star color={"#63f542"} backgroundColor={"#fff"} size={size}/>, title: "Best Move"},
    GOOD_MOVE: {symbol: (size) => <Star color={"#98e187"} backgroundColor={"#ddd"} size={size}/>, title: "Good Move"},
    ALRIGHT_MOVE: {symbol: (size) => <Star color={"#fff"} backgroundColor={"#bbb"} size={size}/>, title: "Alright Move"},
    INACCURACY: {symbol: (size) => <QuestionMark color={"#FFCCD5"} backgroundColor={"#444"} size={size}/>, title: "Inaccuracy"},
    MISTAKE: {symbol: (size) => <QuestionMark color={"#fa878c"} backgroundColor={"#222"} size={size}/>, title: "Mistake"},
    BLUNDER: {symbol: (size) => <QuestionMark color={"#f54242"} backgroundColor={"#000"} size={size}/>, title: "Blunder"}
}